import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {
  HttpErrorHandlerService,
  HandleError,
} from '../config/http-error-handler.service';
import { BaseSvcService } from '../config/base-svc.service';
import { IGetCodes } from 'src/app/interfaces/codes';

export interface IGetNotificationPayload {
  LoggedInUser: string
  NotificationID: number | null
  NotificationMaterialId: string |null
  NotificationAffectedAreaTypeCode: string |null
  NotificationMethodTypeCode: string | null
  NotificationSeverityTypeCode: string |null
  NotificationAcknowledgementTypeCode: string |null
  NotifiedMaterialStatusTypeCode: string |null
  NotificationReleaseDate: any | null
  NotificationWithdrawnDate: any | null
  ReleasedInd: string
  DeletedInd: string
  ScreenName : string | null
  CreationDate: string | null
  UpdationDate : string | null
}

export interface IInsertUpdateNotificationPayload {
  LoggedInUser: string
  NotificationID: any
  NotificationDescription: null | string
  NotificationMaterialId: null | string
  NotificationAffectedAreaTypeCode: null | string
  NotificationMethodTypeCode: null | string
  NotificationSeverityTypeCode:  null | string
  NotificationAcknowledgementTypeCode: null| string
  NotifiedMaterialStatusTypeCode: null |string
  NotificationReleaseDate: null |string
  NotificationWithdrawnDate: string | null
  WithdrawalReasonDescription: string | null
  NotificationStatusTypeCode : null | string
  ReleasedInd: string
  DeletedInd: string
}


@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private handleError: HandleError;
  public url: string;
  public options;
  constructor(
    private http: HttpClient,
    public httpErrorHandler: HttpErrorHandlerService,
    private config: BaseSvcService
  ) {
    this.handleError = httpErrorHandler.createHandleError('HeroesService');
    this.url = this.config.activeURL;
    this.options = this.config._httpoption;
  }

  GetNotifications(payload:IGetNotificationPayload): Observable<any[]> {
    return this.http
      .post<{ data: any[] }>(
        `${this.url}api/GetNotification`,
        payload
      )
      .pipe(
        map((response) => response.data),
        catchError(this.handleError<any[]>('getExamCourses', []))
      );
  }

  InsertUpdateNotification(payload:IInsertUpdateNotificationPayload): Observable<any[]> {
    return this.http
      .post<{ data: any[] }>(
        `${this.url}api/InsertOrUpdateNotification`,
        payload
      )
      .pipe(
        map((response) => response.data),
        catchError(this.handleError<any[]>('InsertUpdateNotification', []))
      );
  }

  GetNotificationAffetedArea(): Observable<IGetCodes[]> {
    return this.http
      .get<{ resultList: IGetCodes[] }>(
        `${this.url}api/GetCodes/NOTIFICATION_AFFECTED_AREA_TYPE`,
        this.options
      )
      .pipe(map((res) => res.resultList),);
  }

  GetNotificationMaterialStatus(): Observable<IGetCodes[]> {
    return this.http
      .get<{ resultList: IGetCodes[] }>(
        `${this.url}api/GetCodes/NOTIFIED_MATERIAL_STATUS_TYPE`,
        this.options
      )
      .pipe( map((res) => res.resultList),);
  }

  GetNotificationSevertyType(): Observable<IGetCodes[]> {
    return this.http
      .get<{ resultList: IGetCodes[] }>(
        `${this.url}api/GetCodes/NOTIFICATION_SEVERITY_TYPE`,
        this.options
      )
      .pipe( map((res) => res.resultList),);
  }

  GetNotificationMethodType(): Observable<IGetCodes[]> {
    return this.http
      .get<{ resultList: IGetCodes[] }>(
        `${this.url}api/GetCodes/NOTIFICATION_METHOD_TYPE`,
        this.options
      )
      .pipe( map((res) => res.resultList),);
  }

  GetNotificationAcknowledgementType(): Observable<IGetCodes[]> {
    return this.http
      .get<{ resultList: IGetCodes[] }>(
        `${this.url}api/GetCodes/NOTIFICATION_ACKNOWLEDGEMENT_TYPE`,
        this.options
      )
      .pipe( map((res) => res.resultList),);
  }

  GetNotificationStatus(): Observable<IGetCodes[]> {
    return this.http
      .get<{ resultList: IGetCodes[] }>(
        `${this.url}api/GetCodes/NOTIFICATION_STATUS_TYPE`,
        this.options
      )
      .pipe( map((res) => res.resultList),);
  }

}
